import {SliderShop} from '../../shops/slider-shop';
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

class ServiceSlider {
    static init(scope = document) {
        scope.querySelectorAll('.service-slider').forEach(slider => {
            if (slider.swiper) {
                slider.swiper.update();
                return;
            }

            slider.classList.add('swiper');

            let wrapper = Array.from(slider.children)
                .find(child => child.classList.contains('swiper-wrapper'));

            if (!wrapper) {
                wrapper = document.createElement('div');
                wrapper.className = 'swiper-wrapper';

                Array.from(slider.children).forEach(slide => {
                    slide.classList.add('swiper-slide');
                    wrapper.append(slide);
                });

                slider.append(wrapper);
            }

            const previousButton = document.createElement('button');
            previousButton.type = 'button';
            previousButton.className = 'service-slider-prev';
            previousButton.setAttribute('aria-label', 'Previous slide');

            const nextButton = document.createElement('button');
            nextButton.type = 'button';
            nextButton.className = 'service-slider-next';
            nextButton.setAttribute('aria-label', 'Next slide');

            const pagination = document.createElement('div');
            pagination.className = 'service-slider-pagination';

            slider.append(previousButton, nextButton, pagination);

            new Swiper(slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    prevEl: previousButton,
                    nextEl: nextButton
                },
                pagination: {
                    el: pagination,
                    clickable: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 2
                    },
                    1366: {
                        slidesPerView: 3
                    }
                }
            });
        });
    }
}

class Accordeon {
    animateContent(content, opening) {
        if (content.accordionAnimation) {
            content.accordionAnimation.cancel();
        }

        if (opening) {
            content.style.display = 'block';
        }

        const styles = window.getComputedStyle(content);
        const fullHeight = content.getBoundingClientRect().height;
        const verticalStyles = {
            paddingTop: styles.paddingTop,
            paddingBottom: styles.paddingBottom,
            marginTop: styles.marginTop,
            marginBottom: styles.marginBottom
        };
        const collapsedStyles = {
            height: '0px',
            paddingTop: '0px',
            paddingBottom: '0px',
            marginTop: '0px',
            marginBottom: '0px'
        };
        const expandedStyles = {
            height: `${fullHeight}px`,
            ...verticalStyles
        };

        content.style.overflow = 'hidden';
        content.style.boxSizing = 'border-box';
        content.style.minHeight = '0';
        const animation = content.animate(
            opening
                ? [collapsedStyles, expandedStyles]
                : [expandedStyles, collapsedStyles],
            {
                duration: 400,
                easing: 'ease'
            }
        );

        content.accordionAnimation = animation;
        animation.onfinish = () => {
            if (content.accordionAnimation !== animation) return;

            content.style.display = opening ? 'block' : 'none';
            content.style.height = '';
            content.style.overflow = '';
            content.style.boxSizing = '';
            content.style.minHeight = '';
            content.accordionAnimation = null;
        };
    }

    init() {
        const initialize = () => {
            document.querySelectorAll('.accordeon_item.active > .accordeon_content').forEach(content => {
                content.style.display = 'block';
                ServiceSlider.init(content);
            });

            document.addEventListener('click', event => {
                const head = event.target.closest('.accordeon_head');
                if (!head) return;

                const item = head.parentElement;
                const content = Array.from(item.children).find(child => child.classList.contains('accordeon_content'));
                if (!content) return;

                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                    this.animateContent(content, false);
                    return;
                }

                item.classList.add('active');
                content.style.display = 'block';
                ServiceSlider.init(content);
                this.initSliderShop();
                this.animateContent(content, true);
            });
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initialize, {once: true});
        } else {
            initialize();
        }
    }

    initSliderShop() {
        SliderShop.init();
    }

    initServiceSlider() {
        ServiceSlider.init();
    }
}

export {Accordeon, ServiceSlider};